module.exports = __webpack_public_path__ + "img/horizontal_3_7_7005.e4337562.png";